import React, { ReactElement } from 'react';
import useThemeColor from 'theme/useThemeColor';

interface SVGProps {
  color?: string;
  width?: number;
  height?: number;
}

export const PlusSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);
  return (
    <svg width={width || 24} height={width || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 5V19M5 12H19"
        stroke={themeColor || '#2C2C2C'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HomeSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);
  return (
    <svg width={width || 28} height={height || 23} viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3334 22.6667V14.6667H16.6667V22.6667H23.3334V12H27.3334L14.0001 0L0.666748 12H4.66675V22.6667H11.3334Z"
        fill={themeColor}
      />
    </svg>
  );
};

export const ChevronDownSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 9L12 15L18 9" stroke={themeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const ChevronUpSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 15L12 9L6 15" stroke={themeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const RightArrowSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);

  return (
    <svg
      width={width || '20'}
      height={height || '10'}
      viewBox="0 0 20 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7709 4.29073C19.7706 4.2905 19.7704 4.29023 19.7702 4.28999L15.688 0.227497C15.3821 -0.0768384 14.8875 -0.0757058 14.5831 0.230153C14.2787 0.535973 14.2799 1.03062 14.5857 1.335L17.3265 4.06249H0.78125C0.349766 4.06249 0 4.41226 0 4.84374C0 5.27523 0.349766 5.62499 0.78125 5.62499H17.3264L14.5857 8.35249C14.2799 8.65686 14.2788 9.15151 14.5831 9.45733C14.8875 9.76323 15.3822 9.76428 15.688 9.45999L19.7702 5.39749C19.7704 5.39726 19.7706 5.39698 19.7709 5.39675C20.0769 5.09136 20.0759 4.59511 19.7709 4.29073Z"
        fill={themeColor || 'white'}
      />
    </svg>
  );
};
export const SchoolSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);

  return (
    <svg
      width={width || '23'}
      height={height || '23'}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6698 20.7007V10.3075C21.6698 9.76502 21.2302 9.32526 20.6877 9.32526H16.0237V6.49746C16.0237 6.23037 15.879 5.98421 15.6459 5.85415L11.859 3.74222C11.8381 3.73055 11.8165 3.72032 11.7948 3.71089V2.50568H13.8341C13.9967 2.50568 14.1287 2.37372 14.1287 2.211V0.722547C14.1287 0.559821 13.9967 0.427859 13.8341 0.427859H11.7948V0.294688C11.7948 0.131963 11.663 0 11.5002 0C11.3374 0 11.2056 0.131963 11.2056 0.294688V3.71089C11.1839 3.72037 11.1623 3.73061 11.1414 3.74222L7.35445 5.8542C7.12111 5.98421 6.9765 6.23043 6.9765 6.49752V9.32526H2.31243C1.76998 9.32526 1.33033 9.76502 1.33033 10.3075V20.7006C0.913053 20.8895 0.62262 21.3092 0.62262 21.7968C0.62262 22.4614 1.16128 23 1.82575 23H21.1743C21.8388 23 22.3775 22.4614 22.3775 21.7968C22.3774 21.3092 22.087 20.8895 21.6698 20.7007ZM17.8734 12.7487C17.8734 12.4327 18.1296 12.1766 18.4458 12.1766H19.5156C19.8315 12.1766 20.0877 12.4327 20.0877 12.7487V13.8186C20.0877 14.1346 19.8315 14.3907 19.5156 14.3907H18.4458C18.1296 14.3907 17.8735 14.1346 17.8735 13.8186V12.7487H17.8734ZM17.8734 16.1863C17.8734 15.8703 18.1296 15.6142 18.4458 15.6142H19.5156C19.8315 15.6142 20.0877 15.8703 20.0877 16.1863V17.2561C20.0877 17.572 19.8315 17.8282 19.5156 17.8282H18.4458C18.1296 17.8282 17.8735 17.572 17.8735 17.2561V16.1863H17.8734ZM14.436 12.7487C14.436 12.4327 14.692 12.1766 15.008 12.1766H16.0779C16.3937 12.1766 16.65 12.4327 16.65 12.7487V13.8186C16.65 14.1346 16.3937 14.3907 16.0779 14.3907H15.008C14.692 14.3907 14.436 14.1346 14.436 13.8186V12.7487ZM14.436 16.1863C14.436 15.8703 14.692 15.6142 15.008 15.6142H16.0779C16.3937 15.6142 16.65 15.8703 16.65 16.1863V17.2561C16.65 17.572 16.3937 17.8282 16.0779 17.8282H15.008C14.692 17.8282 14.436 17.572 14.436 17.2561V16.1863ZM11.5 6.49976C12.3951 6.49976 13.1207 7.2253 13.1207 8.12034C13.1207 9.01539 12.3951 9.74087 11.5 9.74087C10.605 9.74087 9.87945 9.01533 9.87945 8.12029C9.87945 7.22524 10.605 6.49976 11.5 6.49976ZM9.87721 15.8031C9.87721 15.4871 10.1333 15.231 10.4495 15.231H12.5506C12.8666 15.231 13.1227 15.4871 13.1227 15.8031V20.3105C13.1227 20.4137 13.0952 20.5104 13.0473 20.594H9.953C9.9051 20.5104 9.87738 20.4137 9.87738 20.3105L9.87721 15.8031ZM6.34998 12.7487C6.34998 12.4327 6.60608 12.1766 6.92205 12.1766H7.9919C8.30786 12.1766 8.56396 12.4327 8.56396 12.7487V13.8186C8.56396 14.1346 8.30786 14.3907 7.9919 14.3907H6.92205C6.60608 14.3907 6.34998 14.1346 6.34998 13.8186V12.7487ZM6.34998 16.1863C6.34998 15.8703 6.60608 15.6142 6.92205 15.6142H7.9919C8.30786 15.6142 8.56396 15.8703 8.56396 16.1863V17.2561C8.56396 17.572 8.30786 17.8282 7.9919 17.8282H6.92205C6.60608 17.8282 6.34998 17.572 6.34998 17.2561V16.1863ZM2.91222 12.7487C2.91222 12.4327 3.16832 12.1766 3.48446 12.1766H4.55419C4.87027 12.1766 5.12643 12.4327 5.12643 12.7487V13.8186C5.12643 14.1346 4.87027 14.3907 4.55419 14.3907H3.48452C3.16838 14.3907 2.91228 14.1346 2.91228 13.8186V12.7487H2.91222ZM2.91222 16.1863C2.91222 15.8703 3.16832 15.6142 3.48446 15.6142H4.55419C4.87027 15.6142 5.12643 15.8703 5.12643 16.1863V17.2561C5.12643 17.572 4.87027 17.8282 4.55419 17.8282H3.48452C3.16838 17.8282 2.91228 17.572 2.91228 17.2561V16.1863H2.91222Z"
        fill={themeColor || 'white'}
      />
    </svg>
  );
};

export const BellSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);
  return (
    <svg width={width || 24} height={height || 21} viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 8.6665C20 6.54477 19.1571 4.50994 17.6569 3.00965C16.1566 1.50936 14.1217 0.666504 12 0.666504C9.87827 0.666504 7.84344 1.50936 6.34315 3.00965C4.84285 4.50994 4 6.54477 4 8.6665C4 17.9998 0 20.6665 0 20.6665H24C24 20.6665 20 17.9998 20 8.6665Z"
        fill={themeColor}
      />
    </svg>
  );
};

export const MenuSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);
  return (
    <svg width={width || 48} height={height || 48} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 12H21M3 6H21M3 18H21"
        stroke={themeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);

  return (
    <svg width={width || 48} height={height || 48} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6L18 18" stroke={themeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const FileTextSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8M14 2L20 8M14 2V8H20M16 13H8M16 17H8M10 9H8"
        stroke={themeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MailSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6M22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6M22 6L12 13L2 6"
        stroke={themeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClockSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={themeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PhoneSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.0001 16.92V19.92C22.0012 20.1985 21.9441 20.4741 21.8326 20.7293C21.721 20.9845 21.5574 21.2136 21.3521 21.4018C21.1469 21.5901 20.9046 21.7335 20.6408 21.8227C20.377 21.9119 20.0974 21.945 19.8201 21.92C16.7429 21.5856 13.7871 20.5341 11.1901 18.85C8.77388 17.3146 6.72539 15.2661 5.19006 12.85C3.50003 10.2412 2.4483 7.27097 2.12006 4.17997C2.09507 3.90344 2.12793 3.62474 2.21656 3.3616C2.30518 3.09846 2.44763 2.85666 2.63482 2.6516C2.82202 2.44653 3.04986 2.28268 3.30385 2.1705C3.55783 2.05831 3.8324 2.00024 4.11006 1.99997H7.11006C7.59536 1.9952 8.06585 2.16705 8.43382 2.48351C8.80179 2.79996 9.04213 3.23942 9.11005 3.71997C9.23668 4.68004 9.47151 5.6227 9.81006 6.52997C9.9446 6.8879 9.97372 7.27689 9.89396 7.65086C9.81421 8.02482 9.62892 8.36809 9.36005 8.63998L8.09006 9.90997C9.51361 12.4135 11.5865 14.4864 14.0901 15.91L15.3601 14.64C15.6319 14.3711 15.9752 14.1858 16.3492 14.1061C16.7231 14.0263 17.1121 14.0554 17.4701 14.19C18.3773 14.5285 19.32 14.7634 20.2801 14.89C20.7658 14.9585 21.2095 15.2032 21.5266 15.5775C21.8437 15.9518 22.0122 16.4296 22.0001 16.92Z"
        stroke={themeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FaxSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 13L3.5 20H16L18 13M4 4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V11C2 11.5304 2.21071 12.0391 2.58579 12.4142C2.96086 12.7893 3.46957 13 4 13H20C20.5304 13 21.0391 12.7893 21.4142 12.4142C21.7893 12.0391 22 11.5304 22 11V6C22 5.46957 21.7893 4.96086 21.4142 4.58579C21.0391 4.21071 20.5304 4 20 4H4Z"
        stroke={themeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HomeOutlineSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);

  return (
    <svg width={width || 24} height={height || 22} viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 21V11H13V21M1 8L10 1L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8Z"
        stroke={themeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
        stroke={themeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDownCircleSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);
  return (
    <svg
      x="0px"
      y="0px"
      width={width || '24'}
      height={height || '24'}
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
      fill={themeColor}
    >
      <g>
        <path
          d="M500,990C229.8,990,10,770.2,10,500C10,229.8,229.8,10,500,10c270.2,0,490,219.8,490,490C990,770.2,770.2,990,500,990z M500,39.6C246.2,39.6,39.6,246.2,39.6,500c0,253.8,206.5,460.3,460.4,460.3c253.8,0,460.4-206.5,460.4-460.3C960.4,246.2,753.8,39.6,500,39.6z"
          stroke={themeColor}
          strokeWidth="20"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M817.5,332.7c-17.4-17.4-45.5-17.4-62.9,0L511.1,576.3L267.5,332.7c-17.4-17.4-45.5-17.4-62.9,0c-17.4,17.4-17.4,45.5,0,62.9l275,275c8.7,8.7,20,13,31.4,13c11.4,0,22.7-4.3,31.4-13l275-275C834.9,378.2,834.9,350.1,817.5,332.7z"
          stroke={themeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ChartSVG: React.FC<SVGProps> = ({ color, width, height }): ReactElement => {
  const themeColor = useThemeColor(color);
  return (
    <svg width={width || '28'} height={height || '23'} viewBox="0 0 28 23" fill="none">
      <rect width={width || '28'} height={height || '23'} transform="matrix(-1 0 0 1 28 0)" fill="url(#pattern0)" />
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          {/* @ts-ignore */}
          <use transform="translate(0 -0.000869565) scale(0.00285714 0.00347826)" />
        </pattern>
        <image id="image0" width="350" height="288" />
      </defs>
    </svg>
  );
};
